<script>
    export default {
        methods: {
            onBulkDelete(event) {
                if (!confirm('Are you sure?')) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        },
    };
</script>
